"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var lodash_1 = require("lodash");
var Highcharts = require("highcharts");
exports.baseVDLHighchartsOptions = {
    colors: ['#0e5061', '#1a8099', '#db9500', '#d14019'],
    chart: {
        borderWidth: 0,
        backgroundColor: 'transparent',
        plotShadow: false
    },
    title: {
        style: {
            display: 'none'
        }
    },
    subtitle: {
        style: {
            color: '#6a6a6a',
            font: '12px ProximaNova, sans-serif'
        }
    },
    xAxis: {
        gridLineWidth: 1,
        lineColor: '#C0D0E0',
        tickColor: '#C0D0E0',
        labels: {
            style: {
                color: '#6a6a6a',
                font: '14px ProximaNova, sans-serif'
            }
        },
        title: {
            style: {
                color: '#6a6a6a',
                font: '12px ProximaNova, sans-serif'
            }
        }
    },
    yAxis: {
        lineColor: '#C0D0E0',
        tickColor: '#C0D0E0',
        tickWidth: 1,
        labels: {
            style: {
                color: '#6a6a6a',
                font: '14px ProximaNova, sans-serif'
            }
        },
        title: {
            style: {
                color: '#6a6a6a',
                font: '12px ProximaNova, sans-serif'
            }
        }
    },
    legend: {
        align: 'left',
        x: 20,
        itemStyle: {
            font: '12px ProximaNova, sans-serif',
            fontWeight: '300',
            color: '#6a6a6a'
        },
        itemHoverStyle: {
            color: 'black'
        },
        itemHiddenStyle: {
            color: 'silver'
        }
    },
    annotations: [{
            labels: [{
                    style: {
                        color: '#6a6a6a'
                    }
                }],
        }],
    exporting: {
        enabled: false
    }
};
var Chart = /** @class */ (function (_super) {
    __extends(Chart, _super);
    function Chart(props) {
        var _this = _super.call(this, props) || this;
        // holds the instance of the highchart object
        _this.chart = undefined;
        _this.chartConfig = null;
        _this.updateChartConfig = function (config) {
            // override the default behaviour of the chart
            // update the chart font family
            if (!config.hasOwnProperty('chart')) {
                config['chart'] = {};
            }
            if (!config.chart.hasOwnProperty('style')) {
                config.chart['style'] = {};
            }
            config.chart.style['fontFamily'] = '"ProximaNova","sans-serif"';
            // update the chart credits to hide the hightcharts.com water mark at the bottom of the chart
            if (!config.hasOwnProperty('credits')) {
                config['credits'] = {};
            }
            config.credits['enabled'] = false;
        };
        _this.renderChart = function (id, config) {
            _this.chart = Highcharts.chart(id, config);
        };
        _this.chart = undefined;
        return _this;
    }
    Chart.prototype.componentWillReceiveProps = function (newProps) {
        // compare existing chartConfig and new Config if modified update the chart
        this.updateChartConfig(newProps.config);
        var areEqual = lodash_1.isEqual(this.chartConfig, newProps.config);
        if (!areEqual) {
            this.chartConfig = lodash_1.cloneDeep(newProps.config);
            this.chart.update(newProps.config);
        }
    };
    Chart.prototype.componentDidMount = function () {
        var _a = this.props, id = _a.id, config = _a.config;
        this.updateChartConfig(config);
        // clone the config object and store in temporary variable
        this.chartConfig = lodash_1.cloneDeep(config);
        this.renderChart(id, config);
    };
    Chart.prototype.render = function () {
        var _this = this;
        var id = this.props.id;
        return (React.createElement("div", { id: id, ref: function (chart) {
                _this.chart = chart;
            } }));
    };
    return Chart;
}(React.Component));
exports.Chart = Chart;
